import "./Home.module.css";
import Zahlavi from "@/reusable_sections/Header";
import PrumyslovePraniProVasByznys from "./sections/PrumyslovePraniProVasByznys";
import DesetiletiCistotyADuvery from "./sections/DesetiletiCistotyADuvery";
import IndustrySolutions from "./sections/IndustrySolutions";
import NightLogistics from "./sections/NightLogistics";
import HighestHygieneStandards from "./sections/HighestHygieneStandards";
import GetCustomQuote from "./sections/GetCustomQuote";
import Zapati from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Zahlavi />
      <PrumyslovePraniProVasByznys />
      <DesetiletiCistotyADuvery />
      <IndustrySolutions />
      <NightLogistics />
      <HighestHygieneStandards />
      <GetCustomQuote />
      <Zapati />
    </div>;
}